import {StringUtils} from '../../utils/string.utils';
import {ApiJsonResult} from '../../utils/api/apijsonresult';
import {ScopeQuestionareInProgress} from './ScopeQuestionareInProgress';

export class FeedbackTracker {
    id: number;
    scopeProgramId: number;
    childProgressLevelTrackerId: number;
    childFeedbackMasterJson: string;
    questionare: ScopeQuestionareInProgress[];
    byParent: string;
    byTherapist: string;
    noDays: number
    createdBy: string;
    createdDate: any;
    updatedBy: string;
    updatedDate: any;

    static populate(jsonObject: any): FeedbackTracker {
        let obj = new FeedbackTracker();
        obj.id = jsonObject.id;
        obj.scopeProgramId = jsonObject.scopeProgramId;
        obj.childProgressLevelTrackerId = jsonObject.childProgressLevelTrackerId;
        obj.childFeedbackMasterJson = jsonObject.childFeedbackMasterJson;
        if (!StringUtils.isEmpty(obj.childFeedbackMasterJson)) {
            obj.questionare = JSON.parse(obj.childFeedbackMasterJson);
        }
        obj.byParent = jsonObject.byParent;
        obj.byTherapist = jsonObject.byTherapist;
        obj.noDays = jsonObject.noDays;
        obj.createdBy = jsonObject.createdBy;
        obj.createdDate = jsonObject.createdDate;
        obj.updatedBy = jsonObject.updatedBy;
        obj.updatedDate = jsonObject.updatedDate;
        return obj;
    }

    static formPopulate(obj: FeedbackTracker, jsonObject: any): FeedbackTracker {
        if (obj == null) {
            obj = new FeedbackTracker();
        }
        obj.id = jsonObject.id;
        obj.scopeProgramId = jsonObject.scopeProgramId;
        obj.childProgressLevelTrackerId = jsonObject.childProgressLevelTrackerId;
        obj.childFeedbackMasterJson = jsonObject.childFeedbackMasterJson;
        obj.byParent = jsonObject.byParent;
        obj.byTherapist = jsonObject.byTherapist;
        obj.createdBy = jsonObject.createdBy;
        obj.createdDate = jsonObject.createdDate;
        obj.updatedBy = jsonObject.updatedBy;
        obj.updatedDate = jsonObject.updatedDate;
        return obj;
    }

    static apimapper(apijsonResult: ApiJsonResult): FeedbackTracker {
        let obj = null;
        if (!StringUtils.isEmpty(apijsonResult.outputjson)) {
            let jsonObject = JSON.parse(apijsonResult.outputjson);
            obj = FeedbackTracker.populate(jsonObject);
        }
        return obj;
    }

    static apimapperLst(apijsonResult: ApiJsonResult): FeedbackTracker [] {
        let lst: FeedbackTracker [] = [];
        if (!StringUtils.isEmpty(apijsonResult.outputjson)) {
            let jsonObject = JSON.parse(apijsonResult.outputjson);
            for (let i = 0; i < jsonObject.length; i++) {
                lst.push(FeedbackTracker.populate(jsonObject[i]));
            }
            return lst;
        }
    }
}

